document.addEventListener('DOMContentLoaded', function() {
  const accordionHeaders = document.querySelectorAll('.accordion-header');

  // Initialization: If any item is set to open from Liquid (like the 1st row)
  document.querySelectorAll('.accordion-header[aria-expanded="true"]').forEach(activeHeader => {
    const content = activeHeader.nextElementSibling;
    // Set explicit height so transition works on first close
    content.style.maxHeight = content.scrollHeight + "px";
  });

  accordionHeaders.forEach(header => {
    header.addEventListener('click', function() {
      const content = this.nextElementSibling;
      const isOpen = this.getAttribute('aria-expanded') === 'true';
      const parentList = this.closest('.accordion-list');

      // Close all other accordions in this section
      parentList.querySelectorAll('.accordion-header').forEach(other => {
        if (other !== this) {
          other.setAttribute('aria-expanded', 'false');
          other.nextElementSibling.style.maxHeight = null;
        }
      });

      // Toggle current selection
      if (isOpen) {
        this.setAttribute('aria-expanded', 'false');
        content.style.maxHeight = null;
      } else {
        this.setAttribute('aria-expanded', 'true');
        content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  });
});